import React, { createContext, useState } from "react";
const MyContext = createContext();
const MyContextProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("token"));

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("userDetails") || "{}")
  );

  const updateUser = (newData) => {
    setUser(newData);
    localStorage.setItem("userDetails", JSON.stringify(newData));
  };

  const updateToken = (newData) => {
    console.log("newData: ", newData);
    setToken(newData);
    localStorage.setItem("token", newData);
  };

  return (
    <MyContext.Provider
      value={{
        token,
        updateToken,
        user,
        updateUser,
        setOpen,
        open,
        loading,
        setLoading,
      }}
    >
      {children}
    </MyContext.Provider>
  );
};

export { MyContext, MyContextProvider };
